/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  appToH5.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:24
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/* 原生调用H5方法 */
import Bridge from '@/utils/bridge'
import store from '@/store'

// app调用js的方法 appCallJS, 需要注册
export function appCall () {
  Bridge.registerHandler('appCallJS', (datas, responseCallback) => {
    alert('app调用js方法成功，返回参数' + datas)
    responseCallback('成功了成功了')
  })
}

// app调用js的方法 返回companyId
export function receiveCompanyId () {
  Bridge.registerHandler('receiveCompanyId', (id: string, responseCallback) => {
    store.commit('SET_COMPANY_ID', id)
    responseCallback('成功了成功了')
  })
}

// app调用js的方法 清除缓存
export function clearStorage () {
  Bridge.registerHandler('clearStorage', (id: string, responseCallback) => {
    window.localStorage.clear()
    window.sessionStorage.clear()
    responseCallback('清除缓存成功了')
  })
}

// app调用js的方法 原生直接把chooseUserType接口返回的data（JSON字符串）全部传过来
export function chooseUser () {
  Bridge.registerHandler('chooseUser', (data: string, responseCallback) => {
    const res = !data ? {} : JSON.parse(data)
    store.commit('SET_TOKEN', res.access_token)
    store.commit('SET_INFO', res)
    store.commit('SET_USERID', res.userId)
    responseCallback('成功了')
  })
}

// app调用js的方法 跳转到采购单订单
export function toPurchaseOrder () {
  Bridge.registerHandler('toPurchaseOrder', (data: string, responseCallback) => {
    this.$router.replace('/orderManage/orderReturn')
    responseCallback('成功了')
  })
}

// app调用js的方法 跳转到采购单退单
export function toPurchaseOrderReturn () {
  Bridge.registerHandler('toPurchaseOrderReturn', (data: string, responseCallback) => {
    this.$router.replace({
      path: '/orderManage/orderReturn',
      params: {
        orderToggle: '1',
      }
    })
    responseCallback('成功了')
  })
}

// app调用js的方法 清除h5的登录token缓存
export function clearCacheToken () {
  Bridge.registerHandler('clearCacheToken', (data: string, responseCallback) => {
    store.commit('SET_TOKEN', '')
    responseCallback('成功了')
  })
}

// app调用js的方法 从原生界面返回h5界面,刷新h5界面
export function refreshPage () {
  Bridge.registerHandler('refreshPage', (data: string, responseCallback) => {
    console.log(123443)
    console.log('原生调用h5方法')
    responseCallback('成功了')
  })
}

// app调用js的方法 从原生界面返回h5界面,通知h5userInfo已调整,需要重新刷新
export function refreshUserInfo  () {
  Bridge.registerHandler('refreshUserInfo ', (data: string, responseCallback) => {
    console.log(123443)
    console.log('原生调用h5方法====>refreshUserInfo ')
    // 重新获取一下userInfo
    // store.dispatch('GetInfo')
    responseCallback('原生调用h5方法====>refreshUserInfo 成功了')
  })
}
